import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useRef } from 'react';
import ReactDOM from 'react-dom';
import ToolbarWrapper from './ToolbarWrapper';
const PORTAL_ELEMENT_DEFAULT_ID = 'inline-texttools-portal';
const Portal = ({ children, portalId })=>{
    const containerId = portalId || PORTAL_ELEMENT_DEFAULT_ID;
    const container = useRef(document.getElementById(containerId));
    if (!container.current) {
        const el = document.createElement('div');
        el.id = containerId;
        document.body.appendChild(el);
        container.current = el;
    }
    return /*#__PURE__*/ ReactDOM.createPortal(children, container.current);
};
const PortalWrapper = (_param)=>{
    var { children, refCallback, portalId } = _param, props = _object_without_properties(_param, [
        "children",
        "refCallback",
        "portalId"
    ]);
    const style = _object_spread_props(_object_spread({}, props.style), {
        zIndex: 9999999
    });
    return /*#__PURE__*/ React.createElement(Portal, {
        portalId: portalId
    }, /*#__PURE__*/ React.createElement(ToolbarWrapper, null, /*#__PURE__*/ React.createElement("div", {
        dir: ""
    }, /*#__PURE__*/ React.createElement("div", _object_spread_props(_object_spread({}, props), {
        ref: refCallback,
        style: style
    }), children))));
};
export default (({ portalId })=>()=>{
        const Component = ()=>(props)=>/*#__PURE__*/ React.createElement(PortalWrapper, _object_spread({
                    portalId: portalId
                }, props));
        return {
            desktop: Component,
            mobile: {
                ios: Component,
                android: Component
            }
        };
    });
